function emojiToUnicode(str: string) {
  return str.replace(
    /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
    function (e) {
      return '\\u' + e.charCodeAt(0).toString(16) + '\\u' + e.charCodeAt(1).toString(16)
    },
  )
}

export default emojiToUnicode
